module.exports = "/_next/static/images/weebly-logo-0807b15aca14a3c2cf53338c7e64b6e3.png";